import React from "react"
import { Flex } from "@rebass/grid/emotion"

import { TextElementNova } from "@nutrafol/nutrafol-ui-kit/dist/TextElementNova"

import PlusSmall from "../../../../assets/icons/nova/plus-small.svg"
import Minus from "../../../../assets/icons/nova/minus.svg"

import { Item, AccordionControl } from "./accordionitem.styled"

const AccordionItem = ({ item, index, openItem, handleToggle }) => {
  return (
    <Item open={openItem === index} className={`accordion-item`}>
      <summary onClick={(event) => handleToggle(index, event, item)}>
        <Flex
          alignItems={`center`}
          justifyContent={`space-between`}
          className="flex"
        >
          <TextElementNova
            text={item.title}
            element="h3"
            className="Body-20-Dia-Strong"
          />
          <AccordionControl
            className={openItem === index ? "opened" : "closed"}
          >
            {openItem === index ? <Minus /> : <PlusSmall />}
          </AccordionControl>
        </Flex>
      </summary>
      <TextElementNova
        text={item.content || item.answer}
        element="p"
        className="accordion__content Body-10-Dia-Normal"
      />
    </Item>
  )
}
export default AccordionItem
